import Select from '../select';
import { defineComponent, ref } from 'vue';
import Segmented from '../segmented';
import DatePicker from '../date-picker';
const YearSelectOffset = 10;
const YearSelectTotal = 20;
function YearSelect(props) {
    const { fullscreen, validRange, generateConfig, locale, prefixCls, value, onChange, divRef } = props;
    const year = generateConfig.getYear(value || generateConfig.getNow());
    let start = year - YearSelectOffset;
    let end = start + YearSelectTotal;
    if (validRange) {
        start = generateConfig.getYear(validRange[0]);
        end = generateConfig.getYear(validRange[1]) + 1;
    }
    const suffix = locale && locale.year === '年' ? '年' : '';
    const options = [];
    for (let index = start; index < end; index++) {
        options.push({ label: `${index}${suffix}`, value: index });
    }
    return (<Select size={fullscreen ? undefined : 'small'} options={options} value={year} class={`${prefixCls}-year-select`} onChange={(numYear) => {
            let newDate = generateConfig.setYear(value, numYear);
            if (validRange) {
                const [startDate, endDate] = validRange;
                const newYear = generateConfig.getYear(newDate);
                const newMonth = generateConfig.getMonth(newDate);
                if (newYear === generateConfig.getYear(endDate) &&
                    newMonth > generateConfig.getMonth(endDate)) {
                    newDate = generateConfig.setMonth(newDate, generateConfig.getMonth(endDate));
                }
                if (newYear === generateConfig.getYear(startDate) &&
                    newMonth < generateConfig.getMonth(startDate)) {
                    newDate = generateConfig.setMonth(newDate, generateConfig.getMonth(startDate));
                }
            }
            onChange(newDate);
        }} getPopupContainer={() => divRef.value}/>);
}
YearSelect.inheritAttrs = false;
function MonthSelect(props) {
    const { prefixCls, fullscreen, validRange, value, generateConfig, locale, onChange, divRef } = props;
    const month = generateConfig.getMonth(value || generateConfig.getNow());
    let start = 0;
    let end = 11;
    if (validRange) {
        const [rangeStart, rangeEnd] = validRange;
        const currentYear = generateConfig.getYear(value);
        if (generateConfig.getYear(rangeEnd) === currentYear) {
            end = generateConfig.getMonth(rangeEnd);
        }
        if (generateConfig.getYear(rangeStart) === currentYear) {
            start = generateConfig.getMonth(rangeStart);
        }
    }
    const months = locale.shortMonths || generateConfig.locale.getShortMonths(locale.locale);
    const options = [];
    for (let index = start; index <= end; index += 1) {
        options.push({
            label: months[index],
            value: index,
        });
    }
    return (<Select size={fullscreen ? undefined : 'small'} class={`${prefixCls}-month-select`} value={month} options={options} onChange={(newMonth) => {
            onChange(generateConfig.setMonth(value, newMonth));
        }} getPopupContainer={() => divRef.value}/>);
}
MonthSelect.inheritAttrs = false;
function ModeSwitch(props) {
    const { prefixCls, locale, mode, onModeChange } = props;
    const options = [
        { value: 'month', label: locale.monthView ? locale.monthView : locale.month },
        { value: 'year', label: locale.yearView ? locale.yearView : locale.year },
    ];
    return (<Segmented onChange={(value) => {
            onModeChange(value);
        }} size="small" value={mode} options={options} class={`${prefixCls}-mode-switch`}/>);
}
ModeSwitch.inheritAttrs = false;
export default defineComponent({
    name: 'CalendarHeader',
    inheritAttrs: false,
    props: [
        'mode',
        'prefixCls',
        'value',
        'validRange',
        'generateConfig',
        'locale',
        'mode',
        'fullscreen',
        'defaultHeaderLeftMoreRender',
        'disabledDate',
    ],
    setup(_props, { attrs }) {
        const divRef = ref(null);
        return () => {
            const props = { ..._props, ...attrs };
            const { prefixCls, fullscreen, mode, onChange, onModeChange, defaultHeaderLeftMoreRender, disabledDate, } = props;
            const sharedProps = {
                ...props,
                onChange,
                fullscreen,
                divRef,
            };
            const allowClear = false;
            return (<div class={`${prefixCls}-header`} ref={divRef}>
          <div class={`${prefixCls}-header-left`}>{defaultHeaderLeftMoreRender}</div>
          <div class={`${prefixCls}-header-right`}>
            <ModeSwitch {...sharedProps} onModeChange={onModeChange}/>
            {mode === 'month' && (<DatePicker picker="month" allowClear={allowClear} format="YYYY/MM" popupPlacement="bottomRight" size="small" disabledDate={disabledDate} {...sharedProps} class={`${prefixCls}-date-picker`} getPopupContainer={triggerNode => triggerNode.parentNode}/>)}
            {mode === 'year' && (<DatePicker picker="year" allowClear={allowClear} disabledDate={disabledDate} popupPlacement="bottomRight" size="small" {...sharedProps} class={`${prefixCls}-date-picker`} getPopupContainer={triggerNode => triggerNode.parentNode}/>)}
          </div>
        </div>);
        };
    },
});
